export enum NameSpaces {
  DICTATION = 'dictation',
  FOCUS_WINDOW = 'focus_window',
  REPORTER_SHORTCUT = 'reporter_key_shortcut',
  INSERT_SECTION_HEADER = 'insert_section_header',
  UPDATE_SECTION_HEADERS = 'update_section_headers',
  RECORDER_VOICE_COMMAND = 'recorder_voice_command',
  CROSS_TAB_NOTIFICATION = 'cross_tab_notification',
  CROSS_WINDOW_DATA_REFETCH = 'cross_window_data_refetch',
  ACTIVE_PICKLIST_DATA = 'active_picklist_data',
  DRE = 'dre',
  DEEP_LINK = 'deep_link',
  CROSS_WINDOW_MIRROR_LAYOUT = 'cross_window_mirror_layout',
  WEBHID_NOTIFICATION = 'webhid_notification',
  INPUTREPORT_EVENT = 'inputreport_event',
  CANCEL_REPORT_COUNTDOWN = 'cancel_report_countdown',
  REPORT_FACADE = 'report_facade',
  WORKLIST_ITEM_PATCH = 'worklist_item_patch',
  USER_SETTINGS_PATCH = 'user_settings_patch',
  COMMAND_MODE_AUDIO = 'command_mode_audio',
  COMMAND_MODE_KEY = 'command_mode_key',
}
